import { removeEmojis } from '@myfunnow/web-core/string'

export function useComment(name: Readonly<Ref<string | undefined>>) {
  const { t } = useI18n()

  const isMaskedOrEmptyName = computed(() => !name.value || name.value === '*')
  const displayCommenterName = computed(() => (isMaskedOrEmptyName.value ? t('personal_info_guest') : name.value))

  // Avatar
  const firstNonEmojiLetter = computed(() => (isMaskedOrEmptyName.value ? '' : removeEmojis(name.value as string).charAt(0)))
  const shouldShowDefaultAvatar = computed(() => !firstNonEmojiLetter.value)
  const { localeUpperCaseString: commenterFirstLetter } = useUpperCase(firstNonEmojiLetter)

  return {
    displayCommenterName,
    shouldShowDefaultAvatar,
    commenterFirstLetter,
  }
}
